import { getDecoratorValuesCSS } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/RichText/__internal__/richTextElementUtils";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { getSlateTypographyVariant } from "@faire/retailer-shared/SlateMappings/getSlateTypographyVariant";
import { IRichTextElement } from "@faire/web-api--source/indigofair/data/IRichTextElement";
import { ITextSegment } from "@faire/web-api--source/indigofair/data/ITextSegment";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

interface IProps {
  richTextElement: IRichTextElement | undefined;
}
export const SDUIRichTextRenderer = ({ richTextElement }: IProps) => {
  const { segments } = richTextElement ?? {};

  if (!segments) {
    return null;
  }

  return (
    <span>
      {segments.map((segment, index) => (
        <SDUIRichTextSegment key={index} segment={segment} />
      ))}
    </span>
  );
};

const SDUIRichTextSegment = ({ segment }: { segment: ITextSegment }) => {
  const { content, style } = segment;
  if (!content) {
    return null;
  }
  return (
    <Typography
      style={{
        display: "inline",
        ...getDecoratorValuesCSS(style?.decorators),
      }}
      color={getSlateColorToken(style?.color)}
      variant={getSlateTypographyVariant(style?.type, style?.decorators)}
    >
      {content}
    </Typography>
  );
};
